<template>
  <v-dialog @update:returnValue="setEditItemIdZero" v-model="dialogResult" max-width="500px" persistent>
    <v-card>
      <v-card-text class="text-md-center">
        <v-flex>
          <v-select
            label="Event"
            :items="eventsList"
            v-model="itemData.events_id"
          ></v-select>
        </v-flex>
        <v-flex>
          <v-select
            label="Type"
            :items="notificationTypesList"
            v-model="itemData.vendor"
          ></v-select>
        </v-flex>
        <v-flex>
          <v-text-field
            v-if="itemData.vendor === 'email'"
            outline
            label="Subject"
            v-model="itemData.subject"
          />
        </v-flex>
        <v-flex>
          <v-textarea
            outline
            label="Message"
            v-model="itemData.message"
          ></v-textarea>
        </v-flex>
        <v-flex class="text-md-left" v-if="!isLeadAddedEvent">
          <v-btn small @click="pasteVar('{!!$case_id!!}')">Case ID</v-btn>
          <v-btn small @click="pasteVar('{!!$case_name!!}')">Case name</v-btn>
          <v-btn small @click="pasteVar('{!!$client_salutation!!}')">Client salutation</v-btn>
          <v-btn small @click="pasteVar('{!!$client_name!!}')">Client name</v-btn>
          <v-btn small @click="pasteVar('{!!$quotation_link!!}')">Quotation link</v-btn>
          <v-btn small @click="pasteVar('{!!$agreement_link!!}')">Agreement link</v-btn>
          <v-btn small @click="pasteVar('{!!$date_time_of_funerals!!}')">Date time of funerals</v-btn>
          <v-btn small @click="pasteVar('{!!$amount_of_days!!}')">Amount of days</v-btn>
          <v-btn small @click="pasteVar('{!!$location!!}')">Location</v-btn>
          <v-btn small @click="pasteVar('{!!$selected_package!!}')">Selected Package</v-btn>
          <v-btn small @click="pasteVar('{!!$selected_casket!!}')">Selected Casket</v-btn>
          <v-btn small @click="pasteVar('{!!$selected_products!!}')">Selected Products</v-btn>
          <v-btn small @click="pasteVar('{!!$selected_products_list_text!!}')">Selected Products-Amount List Text</v-btn>
        </v-flex>
        <v-flex>
          <v-combobox
            label="Recipients"
            v-model="selectedRecipients"
            :items="notificationRecipients"
            item-value="id"
            multiple
          >
            <template v-slot:selection="data">
              {{ !isEmailType ? data.item.email : data.item.phone }}
            </template>
            <template v-slot:item="data">
              {{ !isEmailType ? data.item.email : data.item.phone }}
            </template>
          </v-combobox>
        </v-flex>
        <v-flex>
          <v-select
            v-model="selectedRoles"
            :items="roles"
            label="Roles"
            multiple
          ></v-select>
        </v-flex>
        <v-flex v-if="!isLeadAddedEvent">
          <v-checkbox
            label="Send to case Client?"
            v-model="itemData.send_to_client"
          ></v-checkbox>
        </v-flex>
        <v-flex>
          <v-checkbox
            label="Is active"
            v-model="itemData.is_active"
          ></v-checkbox>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" flat @click.stop="editItemDataDecorator">Save</v-btn>
        <v-btn color="primary" flat @click="clearDialogForm()" @click.stop="dialogClose">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import dialogMixins from '@/mixins/EditResourceDialog'
  import eventsAPI from '@/api/resources/events'
  import recipientsAPI from '@/api/resources/recipients'
  import notificationsAPI from '@/api/resources/notifications'
  import notificationsMixins from '@/mixins/Notifications'
  import { mapGetters } from 'vuex'
  import _ from 'lodash'

  export default {
    mixins: [ dialogMixins, notificationsMixins ],
    data () {
      return {
        resource: 'notifications',
        notificationRecipients: [],
        eventsList: [],
        selectedRecipients: [],
        selectedRoles: [],
        isEmailType: false
      }
    },
    computed: {
      ...mapGetters({
        roles: 'allRoles'
      }),
      isLeadAddedEvent () {
        let ev = this.eventsList.find(e => e.value === this.selectedEvent)
        return (ev !== undefined) && ev.text === 'New Lead Added'
      }
    },
    methods: {
      clearDialogForm () {
        this.selectedRecipients = []
        this.selectedRoles = []
        this.isEmailType = false
        this.itemData.events_id = null
        this.itemData.vendor = null
        this.itemData.message = null
        this.itemData.subject = null
      },
      editItemDataDecorator () {
        this.selectedRecipients.forEach((item, i) => {
          if (typeof item !== 'object') {
            this.selectedRecipients[i] = {
              id: null,
              phone: !this.isEmailType ? item : null,
              email: this.isEmailType ? item : null
            }
          }
        })

        this.itemData.recipients = _.map(this.selectedRecipients, (this.isEmailType ? 'email' : 'phone'))
        this.itemData.roles = this.selectedRoles

        this.editItemData()
      },
      pasteVar (v) {
        this.itemData.message = this.itemData.message + v
      }
    },
    watch: {
      'itemData.vendor': (v) => {
        this.isEmailType = v === 'email'
      },
      itemId (newVal, oldVal) {
        if (newVal > 0) {
          eventsAPI.loadEvents().then(result => {
            this.eventsList = result
          })

          recipientsAPI.loadRecipients().then(result => {
            notificationsAPI.getLinkedRecipients(newVal).then(result => {
              this.selectedRecipients = result.recipients

              result.roles.forEach((item, i) => {
                if (this.selectedRoles.indexOf(item.id) === -1) {
                  this.selectedRoles.push(item.id)
                }
              })
            })

            this.notificationRecipients = result
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AppEditNotificationsDialog.vue?1d439579